<template>
	<div class="gb-ghost-schedule"
		v-bind:style="styleGhostSchedule"
		v-if="showGhostSchedule"
	>
		<div class="schedule"></div>
	</div>
</template>
<script>
import { UNIT_WIDTH } from '../data/Const';
import ScheduleListRow from '../data/ScheduleListRow';
export default {
	name: 'GBGhostSchedule',
	props: [
		"ghost_schedule",
		"item",
		"parent",
	],
	computed: {
		showGhostSchedule: function() {
			if (this.ghost_schedule === undefined || this.ghost_schedule === null)
				return false;
			
			if (this.item.item_type === ScheduleListRow.ITEM_TYPE.PROJECT && !this.ghost_schedule.member_code) {
				if (this.ghost_schedule.project_code === this.item.code && this.parent !== null)
					return true;
			} else if (this.item.item_type === ScheduleListRow.ITEM_TYPE.MEMBER && this.ghost_schedule.member_code) {
				if (this.ghost_schedule.member_code === this.item.code && this.ghost_schedule.project_code === this.parent.code)
					return true;
			}
			
			return false;
		},
		styleGhostSchedule: function() {
			let base_date = this.$store.getters.calendarBaseDate;
			let tick_width = UNIT_WIDTH.TICK / this.$store.getters.unitTicks;
			
			let offset_begin_ticks = this.ghost_schedule.begin.offsetTicks(base_date);
			let ticks = this.ghost_schedule.ticks;
			
			let left = offset_begin_ticks * tick_width;
			
			return {
				"bottom": "11px",
				"left": left + "px",
				"width": (ticks * tick_width) + 'px',
			};
		},
	},
};
</script>
<style>
	.gb-ghost-schedule {
		display: inline-block;
		margin-top: 10px;
		height: 27px;
		position: absolute;
		border-radius: 13px;
		border-style: none;
		text-align: center;
	}
	.gb-ghost-schedule .schedule {
		position: absolute;
		height: 100%;
		width:100%;
		opacity: .5;
		border: dotted 3px rgba(0, 0, 0, .5);
		background-color: white;
	}
</style>
